package com.qrkontaq.ui.sections.footer.components

import androidx.compose.runtime.Composable
import com.qrkontaq.ui.sections.footer.FooterLinkStyle
import com.qrkontaq.ui.theme.AppColors
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Text

@Composable
internal fun FooterLink(text: String, path: String) {
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    A(
        href = path,
        attrs = FooterLinkStyle
            .toModifier()
            .color(colors.textSecondary)
            .textDecorationLine(TextDecorationLine.None)
            .onClick {
                it.preventDefault()
                if (path.startsWith("#")) {
                    document.querySelector(path)?.scrollIntoView(
                        js("{ behavior: 'smooth' }")
                    )
                } else {
                    window.location.href = path
                }
            }
            .toAttrs()
    ) {
        Text(text)
    }
}
